import {
  BookOpen,
  CreditCard,
  History,
  LayoutDashboard,
  Library,
  ListChecks,
  Package,
  Server,
  Sparkles,
  Users,
} from "lucide-react";
import { NavLink, Outlet, useNavigate } from "react-router";
import { logo } from "../../images";
import { AdminSearch } from "../../pages/admin/AdminSearch";
import { selectUser } from "../../store/slices/auth";
import { useSelector } from "../../store/store";

const navItems = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { to: "/admin/users", label: "Utilisateurs", icon: Users, end: false },
  {
    to: "/admin/subscriptions",
    label: "Abonnements",
    icon: CreditCard,
    end: false,
  },
  {
    to: "/admin/print-orders",
    label: "Impressions",
    icon: Package,
    end: false,
  },
  { to: "/admin/infra", label: "Infra Heroku", icon: Server, end: false },
  { to: "/admin/jobs", label: "Jobs", icon: ListChecks, end: false },
  { to: "/admin/content", label: "Contenu", icon: Library, end: false },
  { to: "/admin/settings", label: "Réglages", icon: Sparkles, end: false },
  { to: "/admin/audit-logs", label: "Journal", icon: History, end: false },
];

export const AdminLayout = () => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="w-60 shrink-0 bg-white border-r border-gray-200 flex flex-col fixed inset-y-0 left-0">
        <div className="h-16 flex items-center gap-2 px-5 border-b border-gray-100">
          <img alt="Memoirs" src={logo.logoGrey} className="h-10 w-auto" />
          <span className="text-sm font-semibold text-gray-700">Admin</span>
        </div>

        <AdminSearch />

        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {navItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-indigo-50 text-indigo-700"
                    : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-gray-100 space-y-1">
          <button
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-3 w-full px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-900"
          >
            <BookOpen className="w-4 h-4" />
            Retour à l'app
          </button>
          <div className="px-3 py-2 text-xs text-gray-400 truncate">
            {user?.first_name} {user?.last_name}
          </div>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 ml-60 min-w-0">
        <div className="max-w-6xl mx-auto p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
